module.exports = __webpack_public_path__ + "img/19.af10afbe.png";